<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>Desde dónde se emiten los documentos. 
                Ej.: tienda, caja, terminal. Define serie,
                numeración y estado. Úsalo para decir desde
                qué punto se generan cotizaciones, pedidos
                o facturas.</p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Clases
          </h2>
        </div>


        <div class="text-sm text-secondary font-medium tracking-tight">
          Configura las <b>clases de documento</b> en base al <b>tipo de documento</b>.
        </div>
      </div>
      <!-- Header -->
      <div
        class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Clases de Documento</div> -->
          <app-status-filters [selectedStatuses]="selectedStatuses"
            [showStatus]="[1,0]" [typeFilter]="'master'"  (selectionFilterApply)="findAllWithCount()">
          </app-status-filters>
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
              <!-- Show filters button -->
              <!-- <button
              mat-icon-button
              color="primary"
              (click)="sidenav.toggle()"
              matTooltip="Mostrar filtros"
            >
              <mat-icon svgIcon="filter_list"></mat-icon>
            </button> -->
          <!-- Add button (only icon) -->
          <button *canPermissionsOnly="DOCUMENT_CLASS_PERMISSIONS.CREATE" mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nuevo Registro">
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
              [trackBy]="trackByFn">
               <!-- Nombre -->
               <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
                <td mat-cell *matCellDef="let visit" class="text-sm text-uppercase">
                  {{ visit.position }}</td>
              </ng-container>

              <!-- Nombre -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
                <td mat-cell *matCellDef="let visit" class="text-sm text-uppercase leading-tight">
                  <div *ngIf="visit.code">
                    <b style="font-size: 10px;">{{ visit?.code }}</b>
                  </div>
                  {{ visit.name }}</td>
              </ng-container>

              <!-- Tipo de Documento -->
              <ng-container matColumnDef="documentType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo de Doc.</th>
                <td mat-cell *matCellDef="let visit" class="text-sm text-uppercase leading-tight">
                  <div *ngIf="visit.documentType && visit.documentType.code">
                    <b style="font-size: 10px;">{{ visit?.documentType?.code }}</b>
                  </div>
                  {{ visit?.documentType?.name }}</td>
              </ng-container>
              
              <!-- Estado -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Estado</th>
                <td mat-cell *matCellDef="let visit" class="px-6 text-left">
                  <mat-slide-toggle class="custom-slide-toggle primary" [checked]="visit.statusId == 1"
                    [disabled]="!(DOCUMENT_CLASS_PERMISSIONS.UPDATE | hasPermission)"
                    [(ngModel)]="visit.statusId" [color]="'success'" (ngModelChange)="onStatusChange($event, visit)">
                  </mat-slide-toggle>
                </td>
              </ng-container>
  
              <!-- Acciones -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                <td mat-cell *matCellDef="let visit" class="px-6 py-3 text-left">
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button *canPermissionsOnly="DOCUMENT_CLASS_PERMISSIONS.UPDATE" mat-menu-item (click)="openEditModal(visit)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      <span>Editar Registro</span>
                    </button>
                    <button *canPermissionsOnly="DOCUMENT_CLASS_PERMISSIONS.VIEW_AUDIT_LOG" mat-menu-item (click)="openAuditLog(visit)">
                      <mat-icon>history</mat-icon>
                      <span>Ver log de modificaciones</span>
                    </button>
                    <button *canPermissionsOnly="DOCUMENT_CLASS_PERMISSIONS.DELETE" mat-menu-item (click)="openDeleteDialog(visit)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>Eliminar Registro</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>
  
              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
  
              <!-- Fila principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
            </table>
          </div>
        </div>
  
        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageIndex]="pageIndex" [pageSize]="pageSize" (page)="onPageChange($event)"></mat-paginator>
        </div>
      </div>
    </div>
  
      <!-- Modales -->
      <ng-template #addModal>
        <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro</h2>
        <mat-dialog-content class="modal-content">
          <form #createForm="ngForm">
            <mat-tab-group>
              <mat-tab label="Datos Generales">
                <app-form-section title="Información Básica" icon="business" iconColor="blue">
                  <div class="grid grid-cols-2 gap-4">
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label>Código</mat-label>
                      <input matInput [(ngModel)]="currentCreateDocumentClass.code" name="code" required>
                    </mat-form-field>
        
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label>Código Externo</mat-label>
                      <input matInput [(ngModel)]="currentCreateDocumentClass.excode" name="excode" required>
                    </mat-form-field>
        
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label>Nombre</mat-label>
                      <input matInput [(ngModel)]="currentCreateDocumentClass.name" name="name" required>
                    </mat-form-field>
        
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label for="group-select">Compañías</mat-label>
                      <mat-select [formControl]="companyMultiCtrl" placeholder="Seleccione las compañías" [multiple]="true"
                        required>
                        <mat-option>
                          <ngx-mat-select-search [showToggleAllCheckbox]="true"
                            [toggleAllCheckboxIndeterminate]="isIndeterminate" [toggleAllCheckboxChecked]="isChecked"
                            (toggleAll)="toggleSelectAll($event)" [formControl]="companyMultiFilterCtrl"
                            [noEntriesFoundLabel]="'No se encontraron resultados'" [clearSearchLabel]="'Limpiar búsqueda'"
                            [placeholderLabel]="'Buscar compañias...'"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let visit of filteredCompany | async" [value]="visit">
                          {{ visit.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="companyMultiCtrl.hasError('required') && (companyMultiCtrl.dirty || companyMultiCtrl.touched)
                              ">
                        Seleccione compañías
                      </mat-error>
                    </mat-form-field>
                  </div>
                </app-form-section>
                <app-form-section title="Configuración de Documento" icon="settings" iconColor="purple">
                  <div class="grid grid-cols-2 gap-4">
                    <div class="col-span-1">
                      <label>Tipo de Documento</label>
                      <ng-select [(ngModel)]="currentCreateDocumentClass.documentTypeId" [items]="documentTypeList"
                        bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione un tipo de documento"
                        name="documentTypeId" (ngModelChange)="onDocumentTypeSelectionChange(currentCreateDocumentClass, $event)" 
                        [appendTo]="'body'" required>
                        <ng-template ng-label-tmp let-item="item">
                          <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                          <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                        </ng-template>
                      </ng-select>
                    </div>
        
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label for="group-select">Siguiente Documento</mat-label>
                      <mat-select [formControl]="documentMultiCtrl" placeholder="Seleccione el siguiente documento"
                        [multiple]="true">
                        <mat-option>
                          <ngx-mat-select-search [showToggleAllCheckbox]="true"
                            [toggleAllCheckboxIndeterminate]="isIndeterminateDoc" [toggleAllCheckboxChecked]="isCheckedDoc"
                            (toggleAll)="toggleSelectAllDoc($event)" [formControl]="documentMultiFilterCtrl"
                            [noEntriesFoundLabel]="'No se encontraron resultados'" [clearSearchLabel]="'Limpiar búsqueda'"
                            [placeholderLabel]="'Buscar documentos...'"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let doc of filteredDocument | async" [value]="doc">
                          <b>{{doc.code}}</b> - {{ doc.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="documentMultiCtrl.hasError('required') && (documentMultiCtrl.dirty || documentMultiCtrl.touched)">
                        Seleccione documentos
                      </mat-error>
                    </mat-form-field>
        
                    <!--sub apps  -->
                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label>Subaplicaciones que pueden crear este documento</mat-label>
                      <mat-select [formControl]="subMultiCtrl" [compareWith]="compareFn" multiple>
                        @for (aplication of applicationList; track aplication) {
                        <mat-optgroup [label]="aplication.name">
                          @for (subaplication of aplication.subApplications; track subaplication) {
                          <mat-option [value]="subaplication._id">
                            {{ subaplication.name }}
                          </mat-option>
                          }
                        </mat-optgroup>
                        }
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label>Clases de línea permitidas</mat-label>
                      <mat-select
                        multiple
                        [value]="currentCreateDocumentClass.allowedLineClassesIds"
                        (selectionChange)="onAllowedLineClassesChange($event.value)"
                      >
                        @for (line of documentLinesList; track line) {
                          <mat-option [value]="line._id">{{ line.name }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </app-form-section>
              </mat-tab>
              <mat-tab label="Ventas">
                <div class="grid grid-cols-2 gap-4">
                  <div class="col-span-1 mb-1">
                    <label>Condición de Pago</label>
                    <ng-select [(ngModel)]="currentCreateDocumentClass.paymentConditionId" [items]="paymentConditionList"
                      bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione una condición de pago"
                      name="paymentConditionId" [appendTo]="'body'">
                    </ng-select>
                  </div>
      
                  <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Crear documento sobrepasando el límite de crédito del cliente</mat-label>
                    <mat-select [(ngModel)]="currentCreateDocumentClass.canCreateOrderOverCreditLimit"
                      name="canCreateOrderOverCreditLimit">
                      @for (overCreditLimit of overCreditLimitList; track overCreditLimit) {
                      <mat-option [value]="overCreditLimit">
                        {{ getOverCreditLimitLabel(overCreditLimit) }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
      
                  <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Crear documento con facturas vencidas</mat-label>
                    <mat-select [(ngModel)]="currentCreateDocumentClass.canCreateOrderoOverdueInvoice"
                      name="canCreateOrderoOverdueInvoice">
                      @for (overOrderInvoice of overOrderInvoiceList; track overOrderInvoice) {
                      <mat-option [value]="overOrderInvoice">
                        {{ getOverOrderInvoiceLabel(overOrderInvoice) }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
      
                  <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Recalcular precio para unidades de medida sin precio</mat-label>
                    <mat-select [(ngModel)]="currentCreateDocumentClass.recalcPriceForUnpricedUoM"
                      name="recalcPriceForUnpricedUoM">
                      @for (recalcPrice of recalcPriceList; track recalcPrice) {
                      <mat-option [value]="recalcPrice">
                        {{ getRecalcPriceLabel(recalcPrice) }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
      
                  <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Número de aprobaciones requeridas</mat-label>
                    <input matInput [(ngModel)]="currentCreateDocumentClass.numberOfRequiredApprovals"
                      name="numberOfRequiredApprovals" type="number" min="0" required>
                  </mat-form-field>
      
                  <div appearance="fill" class="w-full"></div>
                  
                  @for (toggle of salesToggles; track toggle.field) {
                    @if(!toggle.showToggleForDocumentTypes || toggle.showToggleForDocumentTypes.includes(currentCreateDocumentClass.documentTypeCode)){
                    <app-toggle-option [(ngModel)]="currentCreateDocumentClass[toggle.field]" [name]="toggle.field" [icon]="toggle.icon"
                      [iconColor]="toggle.iconColor" [title]="toggle.title" [description]="toggle.description"
                      [tags]="toggle.tagsDocumentTypes">
                    </app-toggle-option>
                    }
                  }
                </div>
              </mat-tab>
              <mat-tab label="Materiales e Inventario">
                <div class="grid grid-cols-2 gap-4">
                  <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Cantidades de la transacción</mat-label>
                    <mat-select [(ngModel)]="currentCreateDocumentClass.keepsQuotedOfSourceTransaction"
                      name="keepsQuotedOfSourceTransaction">
                      @for (quoted of quotedList; track quoted) {
                      <mat-option [value]="quoted">
                        {{ getQuotedLabel(quoted) }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
        
                  <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Comport. de listas de mat. en las clases de doc.</mat-label>
                    <mat-select [(ngModel)]="currentCreateDocumentClass.materialBundlesBehaviour"
                      name="materialBundlesBehaviour">
                      @for (bundleM of bundlesList; track bundleM) {
                      <mat-option [value]="bundleM">
                        {{ bundleLabels?.[bundleM] || bundleM }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  
                  @for (toggle of materialInventoryToggles; track toggle.field) {
                    @if(!toggle.showToggleForDocumentTypes || !toggle.showToggleForDocumentTypes.length || toggle.showToggleForDocumentTypes.includes(currentCreateDocumentClass.documentTypeCode)){
                    <app-toggle-option [(ngModel)]="currentCreateDocumentClass[toggle.field]" [name]="toggle.field" [icon]="toggle.icon"
                      [iconColor]="toggle.iconColor" [title]="toggle.title" [description]="toggle.description"
                      [tags]="toggle.tagsDocumentTypes">
                    </app-toggle-option>
                    }
                  }
      
                </div>
              </mat-tab>
              <mat-tab label="Requerimientos para acciones" [disabled]="!(DOCUMENT_CLASS_PERMISSIONS.TAB_ACTIONS_REQUIREMENT.VIEW | hasPermission)">
                <div>
                  <div class="md:flex items-center text-center">
                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label></mat-label>
                      <mat-select [(ngModel)]="formAddList.action" name="action">
                        @for (act of listAction; track act) {
                        <mat-option [value]="act">
                          {{ getActionLabel(act) }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
      
                    <div>
                      <ng-container *ngIf="!openFormAdd">
                        <button *canPermissionsOnly="DOCUMENT_CLASS_PERMISSIONS.TAB_ACTIONS_REQUIREMENT.CREATE"
                          mat-icon-button color="primary" (click)="openFormAdd = true"
                          matTooltip="Nuevo Registro">
                          <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                        </button>
                      </ng-container>
                      <ng-container *ngIf="openFormAdd">
                        <button *canPermissionsOnly="DOCUMENT_CLASS_PERMISSIONS.TAB_ACTIONS_REQUIREMENT.CREATE"
                          mat-icon-button color="primary"
                          (click)="openFormAdd = false;resetFormAddList()" matTooltip="Cerrar">
                          <mat-icon>close</mat-icon>
                        </button>
                      </ng-container>
                    </div>
                  </div>
                  <table class="material table-sm">
                    <thead>
                      <tr>
                        <th scope="col" class="text-center">Acción</th>
                        <th scope="col" class="text-center">¿Creado en <br> ERP?</th>
                        <th scope="col" class="text-center">¿Tener viaje?</th>
                        <th scope="col" class="text-center">¿Tener viaje <br> en ERP?</th>
                        <th scope="col" class="text-center">Aplicación</th>
                        <th scope="col" class="text-center">Estados</th>
                        <th scope="col" class="text-center">Estados ERP</th>
                        <th scope="col">
      
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngIf="openFormAdd == true" style="background: #f0f0f033; border-radius: 12px;">
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="formAddList.action" name="action">
                              @for (act of listAction; track act) {
                              <mat-option [value]="act">
                                {{ getActionLabel(act) }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="formAddList.haveExternalTransaction" name="haveExternalTransaction">
                              @for (option of listOptionConditional; track option) {
                              <mat-option [value]="option.code">
                                {{ option.value }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="formAddList.haveTrip" name="haveTrip">
                              @for (option of listOptionConditional; track option) {
                              <mat-option [value]="option.code">
                                {{ option.value }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="formAddList.haveExternalTrip" name="haveExternalTrip">
                              @for (option of listOptionConditional; track option) {
                              <mat-option [value]="option.code">
                                {{ option.value }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="formAddList.applications" name="applications" multiple>
                              @for (app of listApplications; track app) {
                              <mat-option [value]="app">
                                {{ app }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="formAddList.statusIds" name="statusIds" multiple>
                              @for (statusAve of orderStatusAveList; track statusAve) {
                              <mat-option [value]="statusAve.id">
                                {{ statusAve.name }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="formAddList.statusERPIds" name="statusERPIds" multiple>
                              @for (statusErp of orderStatusErpList; track statusErp) {
                              <mat-option [value]="statusErp.id">
                                {{ statusErp.name }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center" style="background-color: #f0f0f033;">
                          <button *canPermissionsOnly="DOCUMENT_CLASS_PERMISSIONS.TAB_ACTIONS_REQUIREMENT.CREATE" color="primary" mat-icon-button (click)="onAddToListRAdd()">
                            <mat-icon class="mat-18">save</mat-icon>
                          </button>
                        </td>
                      </tr>
                      <tr *ngFor="let action of listRequirements; let i = index">
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="action.action" [ngModelOptions]="{standalone: true}"
                              [disabled]="!action.isEditMode">
                              @for (act of listAction; track act) {
                              <mat-option [value]="act">
                                {{ getActionLabel(act) }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="action.haveExternalTransaction" [ngModelOptions]="{standalone: true}"
                              [disabled]="!action.isEditMode">
                              @for (option of listOptionConditional; track option) {
                              <mat-option [value]="option.code">
                                {{ option.value }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="action.haveTrip" [ngModelOptions]="{standalone: true}"
                              [disabled]="!action.isEditMode">
                              @for (option of listOptionConditional; track option) {
                              <mat-option [value]="option.code">
                                {{ option.value }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="action.haveExternalTrip" [ngModelOptions]="{standalone: true}"
                              [disabled]="!action.isEditMode">
                              @for (option of listOptionConditional; track option) {
                              <mat-option [value]="option.code">
                                {{ option.value }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="action.applications" [ngModelOptions]="{standalone: true}"
                              [disabled]="!action.isEditMode" multiple>
                              @for (app of listApplications; track app) {
                              <mat-option [value]="app">
                                {{ app }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="action.statusIds" [ngModelOptions]="{standalone: true}"
                              [disabled]="!action.isEditMode" multiple>
                              @for (statusAve of orderStatusAveList; track statusAve) {
                              <mat-option [value]="statusAve.id">
                                {{ statusAve.name }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="action.statusERPIds" [ngModelOptions]="{standalone: true}"
                              [disabled]="!action.isEditMode" multiple>
                              @for (statusErp of orderStatusErpList; track statusErp) {
                              <mat-option [value]="statusErp.id">
                                {{ statusErp.name }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <ng-container *ngIf="!action.isEditMode">
                            <button *canPermissionsOnly="DOCUMENT_CLASS_PERMISSIONS.TAB_ACTIONS_REQUIREMENT.UPDATE" color="primary" mat-icon-button (click)="updateAction(action)">
                              <mat-icon svgIcon="heroicons_outline:pencil"></mat-icon>
                            </button>
                          </ng-container>
                          <ng-container *ngIf="action.isEditMode">
                            <button *canPermissionsOnly="DOCUMENT_CLASS_PERMISSIONS.TAB_ACTIONS_REQUIREMENT.UPDATE" color="primary" mat-icon-button (click)="onSaveAction(action, i)">
                              <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
                            </button>
                          </ng-container>
                          <button *canPermissionsOnly="DOCUMENT_CLASS_PERMISSIONS.TAB_ACTIONS_REQUIREMENT.DELETE" color="warn" mat-icon-button (click)="onDeleteToListAction(action, i)">
                            <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div *ngIf="listRequirements.length == 0" class="border-t p-8 text-center text-1xl sm:p-10">No hay registros
                    para visualizar.
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="Cloud Sales Mobile">
                <form #createForm="ngForm">
                  <div class="grid grid-cols-2 gap-4">
                    <div class="col-span-2 mb-1">
                      <label>Condición de Expedición</label>
                      <ng-select [(ngModel)]="currentCreateDocumentClass.expeditionConditionId"
                        [items]="expeditionConditionList" bindLabel="name" bindValue="_id" [searchable]="true"
                        placeholder="Seleccione una condición de expedición" name="expeditionConditionId" [appendTo]="'body'">
                        <ng-template ng-label-tmp let-item="item">
                          <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                          <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                        </ng-template>
                      </ng-select>
                    </div>

                    @for (toggle of salesMobile; track toggle.field) {
                      @if(!toggle.showToggleForDocumentTypes || !toggle.showToggleForDocumentTypes.length || toggle.showToggleForDocumentTypes.includes(currentCreateDocumentClass.documentTypeCode)){
                      <app-toggle-option [(ngModel)]="currentCreateDocumentClass[toggle.field]" [name]="toggle.field" [icon]="toggle.icon"
                        [iconColor]="toggle.iconColor" [title]="toggle.title" [description]="toggle.description"
                        [tags]="toggle.tagsDocumentTypes">
                      </app-toggle-option>
                      }
                    }
                    
                    <app-form-section title="¿Quién puede utilizar la clase de pedido?" icon="info" iconColor="blue" class="col-span-2">
                      <div class="grid grid-cols-2 gap-4">
                        @for (toggle of salesMobileSectionCreate; track toggle.field) {
                          @if(!toggle.showToggleForDocumentTypes || !toggle.showToggleForDocumentTypes.length || toggle.showToggleForDocumentTypes.includes(currentCreateDocumentClass.documentTypeCode)){
                          <app-toggle-option [(ngModel)]="currentCreateDocumentClass[toggle.field]" [name]="toggle.field" [icon]="toggle.icon"
                            [iconColor]="toggle.iconColor" [title]="toggle.title" [description]="toggle.description"
                            [tags]="toggle.tagsDocumentTypes"
                            [disabled]="toggle.disabled ? toggle.disabled(this) : false"
                            (valueChange)="toggle.valueChange && this[toggle.valueChange]()">
                          </app-toggle-option>
                          }
                        }
          
                        <ng-container *ngIf="!currentCreateDocumentClass.applyToSubRouteGroup">
                          <mat-form-field appearance="fill" class="col-span-2">
                            <mat-label for="group-select">Grupo de Rutas</mat-label>
                            <mat-select [formControl]="routeGroupMultiCtrl" placeholder="Seleccione los grupos de ruta"
                              [multiple]="true" [disabled]="currentCreateDocumentClass.applyToTheseSubRouteGroup">
                              <mat-option>
                                <ngx-mat-select-search [formControl]="routeGroupMultiFilterCtrl"
                                  [placeholderLabel]="'Buscar grupos de ruta...'"
                                  [noEntriesFoundLabel]="'No se encontraron resultados'"></ngx-mat-select-search>
                              </mat-option>
                              <mat-option *ngFor="let route of filteredGroupRoute | async" [value]="route">
                                <span>
                                  <b *ngIf="getCode(route) as code">
                                    {{ code }} -
                                  </b>{{ route.name }}
                                </span>
          
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-container>
                        <ng-container *ngIf="!currentCreateDocumentClass.applyToAllSalesOffices">
                          <mat-form-field appearance="fill" class="col-span-2">
                            <mat-label>Oficina de Venta</mat-label>
                            <mat-select [formControl]="salesOfficesMultiCtrl" multiple>
                              <mat-option>
                                <ngx-mat-select-search [formControl]="searchOfficeControl"
                                  placeholderLabel="Buscar oficina..."
                                  noEntriesFoundLabel="No se encontraron resultados">
                                </ngx-mat-select-search>
                              </mat-option>
                              @for (office of listFilterSalesOfficeList; track office) {
                              <mat-option [value]="office">
                                <b *ngIf="getCode(office) as code">{{ code }} - </b>{{ office.name }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </ng-container>
                        <ng-container *ngIf="!currentCreateDocumentClass.applyToAllSubRoutes">
                          <mat-form-field appearance="fill" class="col-span-2">
                            <mat-label for="group-select">Rutas</mat-label>
                            <mat-select [formControl]="routeMultiCtrl" placeholder="Seleccione las rutas" [multiple]="true"
                              [disabled]="currentCreateDocumentClass.applyToAllSubRoutes">
                              <mat-option>
                                <ngx-mat-select-search [formControl]="routeMultiFilterCtrl"
                                  [placeholderLabel]="'Buscar grupos de ruta...'"
                                  [noEntriesFoundLabel]="'No se encontraron resultados'"></ngx-mat-select-search>
                              </mat-option>
                              <mat-option *ngFor="let route of filteredRoute | async" [value]="route">
                                <span>
                                  <b *ngIf="getCode(route) as code">
                                    {{ code }} -
                                  </b>{{ route.name }}
                                </span>
          
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-container>
                      </div>
                    </app-form-section>
                  </div>
                </form>
              </mat-tab>
            </mat-tab-group>
          </form>
        </mat-dialog-content>
        <mat-dialog-actions class="modal-actions flex justify-end">
          <button mat-button mat-dialog-close class="align-left">Cancelar</button>
          <button mat-raised-button color="primary" (click)="createDocumentClass()"
            [disabled]="!createForm.valid || !(DOCUMENT_CLASS_PERMISSIONS.CREATE | hasPermission)">Guardar</button>
        </mat-dialog-actions>
      </ng-template>
  
      <!-- Modal Editar -->
      <ng-template #editModal>
        <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro</h2>
        <mat-dialog-content class="modal-content">
          <form #editForm="ngForm">
            <mat-tab-group>
              <mat-tab label="Datos Generales">
                <app-form-section title="Información Básica" icon="business" iconColor="blue">
                  <div class="grid grid-cols-2 gap-4">
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label>Código</mat-label>
                      <input matInput [(ngModel)]="currentUpdateDocumentClass.code" name="code" disabled>
                    </mat-form-field>
        
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label>Código Externo</mat-label>
                      <input matInput [(ngModel)]="currentUpdateDocumentClass.externalKeys.code" name="externalKeys" required>
                    </mat-form-field>
        
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label>Nombre</mat-label>
                      <input matInput [(ngModel)]="currentUpdateDocumentClass.name" name="name" required>
                    </mat-form-field>
        
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label for="group-select">Compañías</mat-label>
                      <mat-select [formControl]="companyMultiCtrl" placeholder="Seleccione las compañías" [multiple]="true"
                        required>
                        <mat-option>
                          <ngx-mat-select-search [showToggleAllCheckbox]="true"
                            [toggleAllCheckboxIndeterminate]="isIndeterminate" [toggleAllCheckboxChecked]="isChecked"
                            (toggleAll)="toggleSelectAll($event)" [formControl]="companyMultiFilterCtrl"
                            [noEntriesFoundLabel]="'No se encontraron resultados'" [clearSearchLabel]="'Limpiar búsqueda'"
                            [placeholderLabel]="'Buscar compañias...'"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let visit of filteredCompany | async" [value]="visit">
                          {{ visit.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="companyMultiCtrl.hasError('required') && (companyMultiCtrl.dirty || companyMultiCtrl.touched) ">
                        Seleccione compañías
                      </mat-error>
                    </mat-form-field>
                  </div>
                </app-form-section>
                <app-form-section title="Configuración de Documento" icon="settings" iconColor="purple">
                  <div class="grid grid-cols-2 gap-4">
                    <div class="col-span-1">
                      <label>Tipo de Documento</label>
                      <ng-select [(ngModel)]="currentUpdateDocumentClass.documentType" [items]="documentTypeList"
                        bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione un tipo de documento"
                        name="documentTypeId" (ngModelChange)="onDocumentTypeSelectionChange(currentUpdateDocumentClass, $event)"
                        [compareWith]="compareById" [appendTo]="'body'" required>
                        <ng-template ng-label-tmp let-item="item">
                          <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                          <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                        </ng-template>
                      </ng-select>
                    </div>
        
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label for="group-select">Siguiente Documento</mat-label>
                      <mat-select [formControl]="documentMultiCtrl" placeholder="Seleccione el siguiente documento"
                        [multiple]="true">
                        <mat-option>
                          <ngx-mat-select-search [showToggleAllCheckbox]="true"
                            [toggleAllCheckboxIndeterminate]="isIndeterminateDoc" [toggleAllCheckboxChecked]="isCheckedDoc"
                            (toggleAll)="toggleSelectAllDoc($event)" [formControl]="documentMultiFilterCtrl"
                            [noEntriesFoundLabel]="'No se encontraron resultados'" [clearSearchLabel]="'Limpiar búsqueda'"
                            [placeholderLabel]="'Buscar documentos...'"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let doc of filteredDocument | async" [value]="doc">
                          <b>{{doc.code}}</b> - {{ doc.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="documentMultiCtrl.hasError('required') &&(documentMultiCtrl.dirty || documentMultiCtrl.touched)">
                        Seleccione documentos
                      </mat-error>
                    </mat-form-field>
        
                    <!--sub apps  -->
                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label>Subaplicaciones que pueden crear este documento</mat-label>
                      <mat-select [formControl]="subMultiCtrl" [compareWith]="compareFn" multiple>
                        @for (aplication of applicationList; track aplication) {
                        <mat-optgroup [label]="aplication.name">
                          @for (subaplication of aplication.subApplications; track subaplication) {
                          <mat-option [value]="subaplication._id">
                            {{ subaplication.name }}
                          </mat-option>
                          }
                        </mat-optgroup>
                        }
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label>Clases de línea permitidas</mat-label>
                      <mat-select [formControl]="allowedLineClassesCtrl" [compareWith]="compareFnClass" multiple>
                        <mat-option *ngFor="let line of documentLinesList" [value]="line._id.toString()">
                          {{ line.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </app-form-section>
              </mat-tab>
              <mat-tab label="Ventas">
                <div class="grid grid-cols-2 gap-4">
                  <div class="col-span-1 mb-1">
                    <label>Condición de Pago</label>
                    <ng-select [(ngModel)]="currentUpdateDocumentClass.paymentCondition" [items]="paymentConditionList"
                      bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione una condición de pago"
                      name="paymentConditionId" (ngModelChange)="onPaymentConditionSelectionChange($event)"
                      [compareWith]="compareById" [appendTo]="'body'">
                    </ng-select>
                  </div>
      
                  <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Crear documento sobrepasando el límite de crédito del cliente</mat-label>
                    <mat-select [(ngModel)]="currentUpdateDocumentClass.canCreateOrderOverCreditLimit"
                      name="canCreateOrderOverCreditLimit">
                      @for (overCreditLimit of overCreditLimitList; track overCreditLimit) {
                      <mat-option [value]="overCreditLimit">
                        {{ getOverCreditLimitLabel(overCreditLimit) }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
      
                  <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Crear documento con facturas vencidas</mat-label>
                    <mat-select [(ngModel)]="currentUpdateDocumentClass.canCreateOrderoOverdueInvoice"
                      name="canCreateOrderoOverdueInvoice">
                      @for (overOrderInvoice of overOrderInvoiceList; track overOrderInvoice) {
                      <mat-option [value]="overOrderInvoice">
                        {{ getOverOrderInvoiceLabel(overOrderInvoice) }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
      
                  <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Recalcular precio para unidades de medida sin precio</mat-label>
                    <mat-select [(ngModel)]="currentUpdateDocumentClass.recalcPriceForUnpricedUoM"
                      name="recalcPriceForUnpricedUoM">
                      @for (recalcPrice of recalcPriceList; track recalcPrice) {
                      <mat-option [value]="recalcPrice">
                        {{ getRecalcPriceLabel(recalcPrice) }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
      
                  <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Número de aprobaciones requeridas</mat-label>
                    <input matInput [(ngModel)]="currentUpdateDocumentClass.numberOfRequiredApprovals"
                      name="numberOfRequiredApprovals" type="number" min="0" required>
                  </mat-form-field>
      
                  <div appearance="fill" class="w-full"></div>
      
                  @for (toggle of salesToggles; track toggle.field) {
                    @if(!toggle.showToggleForDocumentTypes || !toggle.showToggleForDocumentTypes.length || toggle.showToggleForDocumentTypes.includes(currentUpdateDocumentClass.documentTypeCode)){
                    <app-toggle-option [(ngModel)]="currentUpdateDocumentClass[toggle.field]" [name]="toggle.field" [icon]="toggle.icon"
                      [iconColor]="toggle.iconColor" [title]="toggle.title" [description]="toggle.description"
                      [tags]="toggle.tagsDocumentTypes">
                    </app-toggle-option>
                    }
                  }
                </div>
              </mat-tab>
              <mat-tab label="Materiales e Inventario">
                <div class="grid grid-cols-2 gap-4">
                  <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Cantidades de la transacción</mat-label>
                    <mat-select [(ngModel)]="currentUpdateDocumentClass.keepsQuotedOfSourceTransaction"
                      name="keepsQuotedOfSourceTransaction">
                      @for (quoted of quotedList; track quoted) {
                      <mat-option [value]="quoted">
                        {{ getQuotedLabel(quoted) }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
        
                  <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Comport. de listas de mat. en las clases de doc.</mat-label>
                    <mat-select [(ngModel)]="currentUpdateDocumentClass.materialBundlesBehaviour"
                      name="materialBundlesBehaviour">
                      @for (bundleM of bundlesList; track bundleM) {
                      <mat-option [value]="bundleM">
                        {{ bundleLabels?.[bundleM] || bundleM }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  @for (toggle of materialInventoryToggles; track toggle.field) {
                    @if(!toggle.showToggleForDocumentTypes || !toggle.showToggleForDocumentTypes.length || toggle.showToggleForDocumentTypes.includes(currentUpdateDocumentClass.documentTypeCode)){
                    <app-toggle-option [(ngModel)]="currentUpdateDocumentClass[toggle.field]" [name]="toggle.field" [icon]="toggle.icon"
                      [iconColor]="toggle.iconColor" [title]="toggle.title" [description]="toggle.description"
                      [tags]="toggle.tagsDocumentTypes">
                    </app-toggle-option>
                    }
                  }
                </div>
              </mat-tab>
              <mat-tab label="Requerimientos para acciones" [disabled]="!(DOCUMENT_CLASS_PERMISSIONS.TAB_ACTIONS_REQUIREMENT.VIEW | hasPermission)">
                <div>
                  <div class="md:flex items-center text-center">
                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label></mat-label>
                      <mat-select [(ngModel)]="formAddList.action" name="action">
                        @for (act of listAction; track act) {
                        <mat-option [value]="act" [disabled]="getDisabledActions().includes(act)">
                          {{ getActionLabel(act) }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
      
                    <div>
                      <ng-container *ngIf="!openFormAdd">
                        <button *canPermissionsOnly="DOCUMENT_CLASS_PERMISSIONS.TAB_ACTIONS_REQUIREMENT.CREATE"
                          mat-icon-button color="primary" (click)="openFormAdd = true"
                          matTooltip="Nuevo Registro">
                          <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                        </button>
                      </ng-container>
                      <ng-container *ngIf="openFormAdd">
                        <button *canPermissionsOnly="DOCUMENT_CLASS_PERMISSIONS.TAB_ACTIONS_REQUIREMENT.CREATE"
                          mat-icon-button color="primary"
                          (click)="openFormAdd = false;resetFormAddList()" matTooltip="Cerrar">
                          <mat-icon>close</mat-icon>
                        </button>
                      </ng-container>
                    </div>
                  </div>
                  <table class="material table-sm">
                    <thead>
                      <tr>
                        <th scope="col" class="text-center">Acción</th>
                        <th scope="col" class="text-center">¿Creado en <br> ERP?</th>
                        <th scope="col" class="text-center">¿Tener viaje?</th>
                        <th scope="col" class="text-center">¿Tener viaje <br> en ERP?</th>
                        <th scope="col" class="text-center">Aplicación</th>
                        <th scope="col" class="text-center">Estados</th>
                        <th scope="col" class="text-center">Estados ERP</th>
                        <th scope="col">
      
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngIf="openFormAdd == true" style="background: #f0f0f033; border-radius: 12px;">
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="formAddList.action" name="action">
                              @for (act of listAction; track act) {
                              <mat-option [value]="act">
                                {{ getActionLabel(act) }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="formAddList.haveExternalTransaction" name="haveExternalTransaction">
                              @for (option of listOptionConditional; track option) {
                              <mat-option [value]="option.code">
                                {{ option.value }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="formAddList.haveTrip" name="haveTrip">
                              @for (option of listOptionConditional; track option) {
                              <mat-option [value]="option.code">
                                {{ option.value }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="formAddList.haveExternalTrip" name="haveExternalTrip">
                              @for (option of listOptionConditional; track option) {
                              <mat-option [value]="option.code">
                                {{ option.value }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="formAddList.applications" name="applications" multiple>
                              @for (app of listApplications; track app) {
                              <mat-option [value]="app">
                                {{ app }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="formAddList.statusIds" name="statusIds" multiple>
                              @for (statusAve of orderStatusAveList; track statusAve) {
                              <mat-option [value]="statusAve.id">
                                {{ statusAve.name }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="formAddList.statusERPIds" name="statusERPIds" multiple>
                              @for (statusErp of orderStatusErpList; track statusErp) {
                              <mat-option [value]="statusErp.id">
                                {{ statusErp.name }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center" style="background-color: #f0f0f033;">
                          <button *canPermissionsOnly="DOCUMENT_CLASS_PERMISSIONS.TAB_ACTIONS_REQUIREMENT.CREATE" color="primary" mat-icon-button (click)="onAddToListRAdd()">
                            <mat-icon class="mat-18">save</mat-icon>
                          </button>
                        </td>
                      </tr>
                      <tr *ngFor="let action of listRequirements; let i = index">
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="action.action" [ngModelOptions]="{standalone: true}" [disabled]="true">
                              @for (act of listAction; track act) {
                              <mat-option [value]="act">
                                {{ getActionLabel(act) }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="action.haveExternalTransaction" [ngModelOptions]="{standalone: true}"
                              [disabled]="!action.isEditMode">
                              @for (option of listOptionConditional; track option) {
                              <mat-option [value]="option.code">
                                {{ option.value }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="action.haveTrip" [ngModelOptions]="{standalone: true}"
                              [disabled]="!action.isEditMode">
                              @for (option of listOptionConditional; track option) {
                              <mat-option [value]="option.code">
                                {{ option.value }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="action.haveExternalTrip" [ngModelOptions]="{standalone: true}"
                              [disabled]="!action.isEditMode">
                              @for (option of listOptionConditional; track option) {
                              <mat-option [value]="option.code">
                                {{ option.value }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="action.applications" [ngModelOptions]="{standalone: true}"
                              [disabled]="!action.isEditMode" multiple>
                              @for (app of listApplications; track app) {
                              <mat-option [value]="app">
                                {{ app }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="action.statusIds" [ngModelOptions]="{standalone: true}"
                              [disabled]="!action.isEditMode" multiple>
                              @for (statusAve of orderStatusAveList; track statusAve) {
                              <mat-option [value]="statusAve.id">
                                {{ statusAve.name }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <mat-form-field appearance="fill" class="w-full">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="action.statusERPIds" [ngModelOptions]="{standalone: true}"
                              [disabled]="!action.isEditMode" multiple>
                              @for (statusErp of orderStatusErpList; track statusErp) {
                              <mat-option [value]="statusErp.id">
                                {{ statusErp.name }}
                              </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="text-center">
                          <ng-container *ngIf="!action.isEditMode">
                            <button *canPermissionsOnly="DOCUMENT_CLASS_PERMISSIONS.TAB_ACTIONS_REQUIREMENT.UPDATE" color="primary" mat-icon-button (click)="updateAction(action)">
                              <mat-icon svgIcon="heroicons_outline:pencil"></mat-icon>
                            </button>
                          </ng-container>
                          <ng-container *ngIf="action.isEditMode">
                            <button *canPermissionsOnly="DOCUMENT_CLASS_PERMISSIONS.TAB_ACTIONS_REQUIREMENT.UPDATE" color="primary" mat-icon-button (click)="onSaveAction(action, i)">
                              <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
                            </button>
                          </ng-container>
                          <button *canPermissionsOnly="DOCUMENT_CLASS_PERMISSIONS.TAB_ACTIONS_REQUIREMENT.DELETE" color="warn" mat-icon-button (click)="onDeleteToListAction(action, i)">
                            <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div *ngIf="listRequirements.length == 0" class="border-t p-8 text-center text-1xl sm:p-10">No hay registros
                    para visualizar.
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="Cloud Sales Mobile">
                <div class="grid grid-cols-2 gap-4">
                  <div class="col-span-2 mb-1">
                    <label>Condición de Expedición</label>
                    <ng-select [(ngModel)]="currentUpdateDocumentClass.expeditionCondition" [items]="expeditionConditionList"
                      bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione una condición de expedición"
                      name="expeditionConditionId" (ngModelChange)="onConditionExpeditionSelectionChange($event)"
                      [compareWith]="compareById" [appendTo]="'body'">
                      <ng-template ng-label-tmp let-item="item">
                        <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                      </ng-template>
                    </ng-select>
                  </div>
      
                  @for (toggle of salesMobile; track toggle.field) {
                    @if(!toggle.showToggleForDocumentTypes || !toggle.showToggleForDocumentTypes.length || toggle.showToggleForDocumentTypes.includes(currentUpdateDocumentClass.documentTypeCode)){
                    <app-toggle-option [(ngModel)]="currentUpdateDocumentClass[toggle.field]" [name]="toggle.field" [icon]="toggle.icon"
                      [iconColor]="toggle.iconColor" [title]="toggle.title" [description]="toggle.description"
                      [tags]="toggle.tagsDocumentTypes">
                    </app-toggle-option>
                    }
                  }
      
                  <app-form-section title="¿Quién puede utilizar la clase de pedido?" icon="info" iconColor="blue" class="col-span-2">
                    <div class="grid grid-cols-2 gap-4">
                      @for (toggle of salesMobileSectionUpdate; track toggle.field) {
                        @if(!toggle.showToggleForDocumentTypes || !toggle.showToggleForDocumentTypes.length || toggle.showToggleForDocumentTypes.includes(currentUpdateDocumentClass.documentTypeCode)){
                        <app-toggle-option [(ngModel)]="currentUpdateDocumentClass[toggle.field]" [name]="toggle.field" [icon]="toggle.icon"
                          [iconColor]="toggle.iconColor" [title]="toggle.title" [description]="toggle.description"
                          [tags]="toggle.tagsDocumentTypes"
                          [disabled]="toggle.disabled ? toggle.disabled(this) : false"
                          (valueChange)="toggle.valueChange && this[toggle.valueChange]()">
                        </app-toggle-option>
                        }
                      }

                      <ng-container *ngIf="!currentUpdateDocumentClass.applyToSubRouteGroup">
                        <mat-form-field appearance="fill" class="col-span-2">
                          <mat-label for="group-select">Grupo de Rutas</mat-label>
                          <mat-select [formControl]="routeGroupMultiCtrl" placeholder="Seleccione los grupos de ruta"
                            [multiple]="true">
                            <mat-option>
                              <ngx-mat-select-search [formControl]="routeGroupMultiFilterCtrl"
                                [placeholderLabel]="'Buscar grupos de ruta...'"
                                [noEntriesFoundLabel]="'No se encontraron resultados'"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let route of filteredGroupRoute | async" [value]="route">
                              <span>
                                <b *ngIf="getCode(route) as code">
                                  {{ code }} -
                                </b>{{ route.name }}
                              </span>
          
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </ng-container>
                      <ng-container *ngIf="!currentUpdateDocumentClass.applyToAllSalesOffices">
                        <mat-form-field appearance="fill" class="col-span-2">
                          <mat-label>Oficina de Venta</mat-label>
                          <mat-select [formControl]="salesOfficesMultiCtrl" multiple>
                            <mat-option>
                              <ngx-mat-select-search [formControl]="searchOfficeControl"
                                placeholderLabel="Buscar oficina..."
                                noEntriesFoundLabel="No se encontraron resultados">
                              </ngx-mat-select-search>
                            </mat-option>
                            @for (office of listFilterSalesOfficeList; track office) {
                            <mat-option [value]="office">
                              <b *ngIf="getCode(office) as code">{{ code }} - </b>{{ office.name }}
                            </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </ng-container>
                      <ng-container *ngIf="!currentUpdateDocumentClass.applyToAllSubRoutes">
                        <mat-form-field appearance="fill" class="col-span-2">
                          <mat-label for="group-select">Rutas</mat-label>
                          <mat-select [formControl]="routeMultiCtrl" placeholder="Seleccione las rutas" [multiple]="true">
                            <mat-option>
                              <ngx-mat-select-search [formControl]="routeMultiFilterCtrl" [placeholderLabel]="'Buscar grupos de ruta...'"
                                [noEntriesFoundLabel]="'No se encontraron resultados'"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let route of filteredRoute | async" [value]="route">
                              <span>
                                <b *ngIf="getCode(route) as code">
                                  {{ code }} -
                                </b>{{ route.name }}
                              </span>
                      
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </ng-container>
                    </div>
                  </app-form-section>
                </div>
              </mat-tab>
            </mat-tab-group>
          </form>
        </mat-dialog-content>
        <mat-dialog-actions class="modal-actions flex justify-end">
          <button mat-button mat-dialog-close class="align-left">Cancelar</button>
          <button mat-raised-button color="primary" (click)="updateDocumentClass(currentUpdateDocumentClass._id)"
            [disabled]="!editForm.valid || !(DOCUMENT_CLASS_PERMISSIONS.UPDATE | hasPermission)">Guardar</button>
        </mat-dialog-actions>
      </ng-template>
  
      <ng-template #deleteDialog let-data>
        <div class="flex items-start space-x-2 mb-4">
          <div class="flex items-center">
            <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
              style="font-size: 32px;"></mat-icon>
          </div>
          <div class="grid">
            <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
            <mat-dialog-content class="modal-content mt-0">
              <p>¿Está seguro que desea eliminar el registro?</p>
            </mat-dialog-content>
          </div>
        </div>
        <mat-dialog-actions class="modal-actions flex justify-end">
          <button mat-button mat-dialog-close class="align-left">Conservar</button>
          <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
        </mat-dialog-actions>
      </ng-template>
    </div>

    <!-- Filtros -->
    <mat-sidenav #sidenav mode="side" position="end" class="mat-sidenav-content p-0" closed>
      <div class="flex items-center justify-between bg-blue-950 text-white p-4">
        <mat-icon svgIcon="filter_list" class="text-white mr-2 w-4 h-4"></mat-icon>
        <h2 class="text-current text-lg font-bold">Filtros</h2>
        <button mat-icon-button class="ml-auto" (click)="sidenav.close()" matTooltip="Cerrar">
          <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
      </div>
    
      <!-- Compañía -->
      <!-- <div class="mt-6 px-4">
               <div class="w-full mb-4">
                 <label for="company-select" class="block text-gray-700">Compañía</label>
                 <hr class="m-1">
                 <ng-select
                   [(ngModel)]="selectedCompanyIds"
                   [items]="companyList"
                   bindLabel="name"
                   bindValue="_id"
                   [multiple]="true"
                   placeholder="Seleccione Compañía"
                   [compareWith]="compareById"
                   (ngModelChange)="onCompanySelectionChange($event)"
                 >
                 </ng-select>
               </div>
             </div> -->
    
      <div class="flex justify-between mt-4 px-4">
        <button mat-button class="align-left text-gray-700 border border-gray-300" (click)="clearFilters()">
          Limpiar
        </button>
        <button mat-raised-button class="ml-auto bg-blue-950 text-white" (click)="findAllWithCount()">
          Aplicar
        </button>
      </div>
    </mat-sidenav>
    
    <app-filter (onFilterEvent)="findAllWithCount()" (onCleanEvent)="handleFilterClean()" (onPanelOpened)="onFilterPanelOpened()">
      <app-configuration-filters [form]="form" [company]="true" [loadData]="loadFiltersData"></app-configuration-filters>

      <app-documents-filters [form]="form" [documentType]="true" [loadData]="loadFiltersData"></app-documents-filters>
    </app-filter>
  </mat-sidenav-container>
  